// Copyright (c) 2024 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { UpgradeModal } from '@/components/upgrade-modal';
import { useDisclosure } from '@/hooks/use-disclosure';
import { Chip, ChipProps } from '@mui/material';

type Props = Omit<ChipProps, 'onClick' | 'label' | 'color'> & {
  /**
   * The organization's plan type
   */
  plan: string;
};

/**
 * A component that displays a pill indicating the organization's plan status.
 * For free plans, it shows a clickable pill that opens an upgrade modal.
 * For other plans, it returns null.
 */
export function PlanStatusPill(props: Props) {
  const upgradeModal = useDisclosure();

  // Only show for free plans
  if (props.plan !== 'FREE') {
    return null;
  }

  return (
    <>
      <Chip
        {...props}
        size="small"
        label="Free"
        color="success"
        onClick={upgradeModal.open}
        sx={{ marginLeft: 1, ...props.sx }}
      />
      <UpgradeModal isOpen={upgradeModal.isOpen} onClose={upgradeModal.close} />
    </>
  );
}
